import axios from 'axios';

// If REACT_APP_BACKEND_URL is unset, use relative URLs (same-origin on Vercel).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});
